import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FinanceService, HolidayItem } from '../finance.service';

interface MonthGroup {
  monthLabel: string;
  items: HolidayItem[];
}

@Component({
  selector: 'app-holiday-calendar-modal',
  templateUrl: './holiday-calendar-modal.component.html',
  styleUrl: './holiday-calendar-modal.component.scss',
})
export class HolidayCalendarModalComponent implements OnInit {
  year: number;
  loading = true;
  errorMessage: string | null = null;
  groupedHolidays: MonthGroup[] = [];

  constructor(
    private readonly dialogRef: MatDialogRef<HolidayCalendarModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: { year: number },
    private readonly financeService: FinanceService,
  ) {
    this.year = data.year;
  }

  ngOnInit(): void {
    this.financeService.getHolidaysForYear(this.year).subscribe({
      next: (data) => {
        this.groupedHolidays = this.groupByMonth(data.holidays);
        this.loading = false;
      },
      error: (err) => {
        this.errorMessage = 'Unable to load holidays.';
        this.loading = false;
        console.error('Holiday year load failed', err);
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  formatMonthDate(item: HolidayItem): string {
    const dd = String(item.day).padStart(2, '0');
    const yy = String(this.year).slice(-2);
    return `${dd}-${item.month}-${yy}`;
  }

  monthShort(item: HolidayItem): string {
    const yy = String(this.year).slice(-2);
    return `${item.month} ${yy}`;
  }

  private groupByMonth(items: HolidayItem[]): MonthGroup[] {
    const map = new Map<number, MonthGroup>();
    for (const item of items) {
      const key = item.monthNumber;
      if (!map.has(key)) {
        map.set(key, { monthLabel: `${item.month} ${String(this.year).slice(-2)}`, items: [] });
      }
      map.get(key)!.items.push(item);
    }
    return Array.from(map.values()).sort((a, b) => a.items[0].monthNumber - b.items[0].monthNumber);
  }
}
